import { createSelector } from '@ngrx/store';

import { BaseState, getBaseState } from '../reducers';
import { ConstantsState } from './constants.reducers';

export const getConstantState = createSelector(
  getBaseState,
  (state: BaseState) => state.constants
);

export const getConstantsLoading = createSelector(
  getConstantState,
  (state: ConstantsState) => state.loading
);

export const getConstantsLoaded = createSelector(
  getConstantState,
  (state: ConstantsState) => state.loaded
);

export const getConstants = createSelector(
  getConstantState,
  (state: ConstantsState) => state.constants
);
